export let versionData = {
  "shortSHA": "2673f8a17",
  "SHA": "2673f8a17a4f684fe1b91748fa455f2327d451a3",
  "branch": "developer",
  "lastCommitAuthor": "'peter.maquiran'",
  "lastCommitTime": "'Tue Jan 6 11:58:59 2026 +0100'",
  "lastCommitMessage": "set expediente as default and fix assinar diploma",
  "lastCommitNumber": "6155",
  "changeStatus": "On branch developer\nYour branch is up to date with 'origin/developer'.\n\nChanges to be committed:\n  (use \"git restore --staged <file>...\" to unstage)\n\tnew file:   src/app/core/gabinete/repository/task-remote-repository.ts\n\tnew file:   src/app/module/gabinete/chat.module.ts\n\tnew file:   src/app/module/gabinete/data/repository/task-repo.service.spec.ts\n\tnew file:   src/app/module/gabinete/data/repository/task-repo.service.ts\n\tmodified:   version/git-version.ts",
  "changeAuthor": "peter.maquiran"
}